module.exports = __webpack_public_path__ + "61f7cb3d591067c7046d65f299f2f5e7.png";